import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import {
  ADMIN_MAIN_ROUTE,
  ADMIN_ROUTES,
} from '../../constants/admin.routing.constants';
import { FEATURE_FLAGS } from '../../constants/feature-flags.constants';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';

/**
 * canMatch + redirectTo on the same route throws NG04014 (redirects run before guards).
 * This guard replaces that combo: it matches normally and redirects via UrlTree instead.
 */
export const workflowBuilderRedirectGuard: CanMatchFn = (_route, segments) => {
  const featureFlagsService = inject(FeatureFlagsService);
  if (
    !featureFlagsService.getFeatureFlagValue(
      FEATURE_FLAGS.WORKFLOW_CONFIGURATION.workflow_builder
    )
  ) {
    return true;
  }
  const workflowId = segments[segments.length - 1]?.path;
  return inject(Router).createUrlTree([
    '/',
    ADMIN_MAIN_ROUTE,
    ADMIN_ROUTES.WORKFLOW.CUSTOM_WORKFLOWS,
    workflowId,
  ]);
};
